export default function Valid(state) {
    var valid = true;
  
    if (state.pagamento === 'Escolha') {
      valid = false;
    }
    return valid;
  }